import { octicons } from '@chaine/keychaine'

import { ConditionsSelection } from '..'
import { ConditionTypesUnion } from '.'

export enum ConditionConjunctionEnum {
  AND = 'AND',
  OR = 'OR'
}

export interface IConditions {
  /**
   * The conjunction to evaluate the conditions, e.g. (AND, OR)
   */
  conjunction: ConditionConjunctionEnum
  /**
   * The array of condition to evaluate
   */
  list: Array<ConditionTypesUnion>
}

export type BaseConditionCardProps = {
  conditions: IConditions | null
  defaultCondition: ConditionTypesUnion
  description: string
  handleAddNewConditionClick: () => void
  handleConditionsCardClick: () => void
  handleDeleteButtonClick: () => void
  handleSetSelectedCondition: (condition: ConditionsSelection | null) => void
  handleUpdateConditions: (conditions: IConditions | null) => void
  icon: octicons.Icon
  isSelected: boolean
  itemIndex?: number,
  shouldDisplayTitle: boolean,
  shouldShowPlusButton: boolean
}
